import React from 'react';
import generateStyle from '../branding/generateStyle';

class BrandingStyle extends React.PureComponent {
    componentDidMount() {
        this.styleTag = document.createElement('style');
        this.styleTag.type = 'text/css';
        this.renderCss();
        document.getElementsByTagName('head')[0].appendChild(this.styleTag);
    }

    componentWillUnmount() {
        this.styleTag.remove();
        delete this.styleTag;
    }

    renderCss() {
        if (!this.styleTag) {
            return;
        }
        this.styleTag.innerHTML = generateStyle(this.props);
    }

    render() {
        this.renderCss();
        return null;
    }
}

export default BrandingStyle;
